/**
 * External dependencies
 */
import { combineReducers } from 'redux';
/**
 * Internal dependencies
 */

import { createReducer } from 'state/utils';
import {
    CURRENT_CLOUD_BACKUP_RECEIVE,
    CURRENT_CLOUD_BACKUP_REQUEST,
    CURRENT_CLOUD_BACKUP_REQUEST_SUCCESS,
    CURRENT_CLOUD_BACKUP_REQUEST_FAILURE,
} from 'state/action-types';

export const requesting = createReducer(false, {
    [CURRENT_CLOUD_BACKUP_REQUEST]: () => true,
    [CURRENT_CLOUD_BACKUP_REQUEST_SUCCESS]: () => false,
    [CURRENT_CLOUD_BACKUP_REQUEST_FAILURE]: () => false,
});

const items = createReducer(null, {
    [CURRENT_CLOUD_BACKUP_RECEIVE]: (state, action) => action.payload.backup,
});

export const error = createReducer(false, {
    [CURRENT_CLOUD_BACKUP_REQUEST]: () => false,
    [CURRENT_CLOUD_BACKUP_REQUEST_SUCCESS]: () => false,
    [CURRENT_CLOUD_BACKUP_REQUEST_FAILURE]: () => true,
});

export default combineReducers({
    items,
    requesting,
    error
});
